import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Subscription} from 'rxjs';
import {NotifierService} from 'angular-notifier';
import {MessageService} from '../message.service';
import {RestApiService} from '../rest-api.service';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {SocketService} from '../socket.service';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {FormControl} from '@angular/forms';
import {AngularGridInstance, Column, GridOption} from 'angular-slickgrid';

@Component({
    selector: 'app-dashboard-chr',
    templateUrl: './dashboard-chr.component.html',
    styleUrls: ['./dashboard-chr.component.css']
})
export class DashboardChrComponent implements OnInit, OnDestroy {

    isCollapsed: boolean;
    // clientId: number;
    clientName: string;
    userGroups: any;
    userGroupId: number;
    groupName: string;
    grpLevel: number;
    respObject: any;
    tilesData = [];
    isLabel0: boolean;
    isLabel1: boolean;
    isLabel2: boolean;
    islead: boolean;
    cat1: any;
    cat2: any;
    cat3: any;
    cat4: any;
    private userAuth: Subscription;
    private ticketSub: Subscription;
    userGroupSelected: number;
    private ticketType: number;
    ticketTypeLoaded = false;
    radioButton = [];
    selectedData = [];
    private notifier: NotifierService;
    hideChart: boolean;
    modal: any;
    radius: number;
    clientId: number;
    categories = [];
    categorySelected: number;
    errorMessage: string;
    isError = false;
    users = [];
    userSelected: number;
    @ViewChild('content') content;
    private dashboardSubscribe: Subscription;
    isLoading: boolean;
    @ViewChild('addCategory') private addCategory;
    private commentDialogRef: MatDialogRef<any, any>;
    private baseCategories = [];
    ticketTypes = [];
    cat = [];
    private selectedCategories: string;
    getTicketType: boolean;
    private UpdateDialogRefUpdate: MatDialogRef<any, any>;
    firstLevelSelected: any;
    secondLevelSelected: any;
    sevenLevelSelected: any;
    isUpdate: boolean;
    workType: string;
    workspaces = [];
    columnDefinitions: Column[];
    gridOptions: GridOption;
    dataset = [];
    angularGrid: AngularGridInstance;
    totalData: number;
    selectedTitles: any[];
    gridObj: any;
    gridWidth: number;
    seq: number;
    lastId: number;
    firstId: number;
    limits = [];
    limit: number;
    totalCat: number;
    displayCount: number;
    private addedCat = [];
    dataLoaded: boolean;
    rowSelected = [];
    page: number;
    private prevDisplayCount: number;
    private prevTotalCount: number;
    typeSeq: number;

    constructor(private messageService: MessageService, private _rest: RestApiService,
                private actRoute: ActivatedRoute, private route: Router, private dialog: MatDialog, notifier: NotifierService,
                private modalService: NgbModal, private socketService: SocketService) {
        this.notifier = notifier;
        this.dashboardSubscribe = this.socketService.dashboardSubject.subscribe((data) => {
            if (this.userGroupId === data.groupId) {
                // console.log('-->: ' + JSON.stringify(data));
                const menuId = data.menuId;
                const displayelem = document.getElementById('display_' + menuId);
                if (displayelem !== undefined && displayelem !== null) {
                    displayelem.classList.remove('none');
                }
                const countelem = document.getElementById('count_' + menuId);
                if (countelem !== undefined && countelem !== null) {
                    countelem.innerText = (Number(countelem.innerText) + 1) + '';
                }
            }
        });
    }

    angularGridReady(angularGrid: AngularGridInstance) {
        this.angularGrid = angularGrid;
        this.gridObj = angularGrid && angularGrid.slickGrid || {};
    }

    ngOnInit() {
        this.limits = [{value: 200}, {value: 400}, {value: 600}];
        this.limit = this.limits[0].value;
        this.gridOptions = {
            enableAutoResize: true,       // true by default
            enableCellNavigation: true,
            enableFiltering: true,
            editable: true,
            rowSelectionOptions: {
                selectActiveRow: false
            },
            preselectedRows: [],
            enableCheckboxSelector: true,
            enableRowSelection: true,
            enableAutoTooltip: true,
            autoTooltipOptions: {
                /** are tooltip enabled for all cells? */
                enableForCells: true,
                /** are tooltip enabled for column headers */
                enableForHeaderCells: false,
                /** what is the maximum tooltip length in pixels (only type the number) */
                maxToolTipLength: 500
            },
        };
        this.dataset = [];
        this.isUpdate = false;
        this.isLoading = false;
        this.isLabel0 = false;
        this.isLabel1 = false;
        this.isLabel2 = false;
        this.islead = false;
        this.hideChart = true;
        this.categorySelected = 0;
        this.userSelected = 0;
        this.actRoute.queryParams.subscribe(params => {
            const token = params['token'];
            this.clientId = params['clientId'];
            const userId = params['userId'];
            const encodedUserName = params['name'];
            let userName;
            if (encodedUserName) {
                userName = this.messageService.xorEncode(atob(encodedUserName), this.messageService.SECRET_TOKEN);
            }
            // this.cat1 = params['cat1'];
            // this.cat2 = params['cat2'];
            const sourceType = params['srcType'];
            // const ticketType1 = params['ticket_type1'];
            // const ticketType2 = params['ticket_type2'];
            // this.cat3 = params['cat3'];
            // this.cat4 = params['cat4'];
            let callback = params['callback'];
            // let count = 0;
            // let isIncident = false;
            // let isProblem = false;

            // // console.log(ticketType1, typeof ticketType1);
            if (this.clientId !== undefined && token !== undefined && userName !== undefined) {
                // // console.log('from panel');
                if (callback === 'undefined' || callback === undefined || callback === '') {
                    callback = this.messageService.API_ROOT;
                }
                if (sourceType !== 'undefined' && sourceType !== undefined && sourceType !== '') {
                    this.messageService.saveSourceType(sourceType);
                }
                this.messageService.clearSession();
                const data = {clientId: this.clientId, token: token, loginName: userName};
                this._rest.tokenValidation(data).subscribe((res) => {
                    this.respObject = res;
                    if (this.respObject.success) {
                        // sessionStorage.setItem('id', this.respObject.details);
                        // sessionStorage.setItem('data', token);
                        this.messageService.addSessionData(this.respObject.details, token, this.clientId);
                        this.messageService.tokenSubject.next();
                        sessionStorage.removeItem('dd');
                        this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                            this.clientName = auth[0].client;
                            this.userGroups = auth[0].groupId;
                            // console.log(this.messageService.getSupportGroup());
                            // if (this.messageService.getSupportGroup() === null) {
                            if (this.userGroups !== undefined) {
                                this.userGroupId = this.userGroups[0].groupId;
                                this.groupName = this.userGroups[0].grpName;
                                this.grpLevel = this.userGroups[0].level;
                            }
                            this.userGroupSelected = this.userGroupId;
                            // this.name = userName;
                            // console.log('-----token validation-------');
                            this.onPageLoad();
                            // }
                        });
                        // this.onPageLoad();
                    } else {
                        this.messageService.clearSession();
                        alert(this.messageService.URL_TOKEN_ERROR1);
                        window.location.href = callback;
                        // console.log(this.respObject.errorMessage);
                    }
                }, (err) => {
                    this.messageService.clearSession();
                    alert(this.messageService.TOKEN_TIMEOUT_ERROR);
                    window.location.href = callback;
                });
            } else if (token !== undefined && userId !== undefined) {
                this.messageService.addSessionData(this.messageService.xorEncode(atob(userId), this.messageService.SECRET_TOKEN), token, this.clientId);
                this.messageService.tokenSubject.next();
                sessionStorage.removeItem('dd');
                this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                    this.clientName = auth[0].client;
                    this.clientId = auth[0].clientId;
                    this.userGroups = auth[0].groupId;
                    if (this.userGroups !== undefined) {
                        this.userGroupId = this.userGroups[0].groupId;
                        this.groupName = this.userGroups[0].grpName;
                        this.grpLevel = this.userGroups[0].level;
                    }
                    this.userGroupSelected = this.userGroupId;
                    this.onPageLoad();
                });
            } else {
                if (this.messageService.getUserId() === null || this.messageService.getToken() === null) {
                    this.messageService.clearSession();
                    window.location.href = this.messageService.API_ROOT;
                } else {
                    // this.sourceType = 'web';
                    if (this.messageService.clientId) {
                        this.clientId = this.messageService.clientId;
                        this.clientName = this.messageService.client;
                        this.userGroups = this.messageService.groupId;
                        if (this.userGroups !== undefined) {
                            if (this.messageService.getSupportGroup() === null) {
                                this.userGroupId = this.userGroups[0].groupId;
                                this.groupName = this.userGroups[0].grpName;
                                this.grpLevel = this.userGroups[0].level;
                            } else {
                                const group = this.messageService.getSupportGroup();
                                this.userGroupId = group.groupId;
                                this.groupName = group.grpName;
                                this.grpLevel = group.level;
                            }
                            this.userGroupSelected = this.userGroupId;
                        }
                        // console.log('-----within page-------');
                        this.onPageLoad();
                    } else {
                        this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                            this.clientId = auth[0].clientId;
                            this.clientName = auth[0].client;
                            this.userGroups = auth[0].groupId;
                            if (this.userGroups !== undefined) {
                                if (this.messageService.getSupportGroup() === null) {
                                    this.userGroupId = this.userGroups[0].groupId;
                                    this.groupName = this.userGroups[0].grpName;
                                    this.grpLevel = this.userGroups[0].level;
                                } else {
                                    const group = this.messageService.getSupportGroup();
                                    this.userGroupId = group.groupId;
                                    this.groupName = group.grpName;
                                    this.grpLevel = group.level;
                                }
                                this.userGroupSelected = this.userGroupId;
                            }
                            // console.log('-----page refresh-------');
                            this.onPageLoad();
                            // }
                        });
                    }
                }
            }
        });
        // -------------------------------------------------
        // window.addEventListener('click', function (event) {
        //     // console.log('AAAAAAAAAAAA==========', this.modal.close());
        // });
    }

    handleSelectedRowsChanged(e, args) {
        // console.log(JSON.stringify(args));
        if (Array.isArray(args.rows)) {
            // console.log('handleSelectedRowsChanged------>' + JSON.stringify(args.rows));
            this.rowSelected = args.rows;
            this.selectedTitles = args.rows.map(idx => {
                // console.log(idx.row);
                const item = this.gridObj.getDataItem(idx);
                // console.log(item);
                if (item) {
                    return item.id;
                }
            });

            // console.log(JSON.stringify(this.selectedTitles));
            // this.rowSelected = this.selectedTitles;
            // for (let i = 0; i < this.selectedTitles.length; i++) {
            //     let matched = false;
            //     for (let j = 0; j < this.rowSelected.length; i++) {
            //         if (this.rowSelected[j] === this.selectedCategories[i]) {
            //             matched = true;
            //             break;
            //         }
            //     }
            //     // if(!matched){
            //     //     this.rowSelected.push()
            //     // }
            // }

            // console.log(JSON.stringify(this.rowSelected));
        }
    }

    onPageLoad() {
        this.displayCount = 0;
        this.columnDefinitions = [
            {id: 'header', name: 'Header', field: 'header', maxWidth: 250, sortable: true, filterable: true},
            {id: 'category', name: 'Category', field: 'category', maxWidth: 300, sortable: true, filterable: true},
            {id: 'title', name: 'Category Path', field: 'title', minWidth: 100, sortable: true, filterable: true}
        ];
        this.getTicketType = true;
        this.isLoading = true;
        this.tilesData = [];
        if (this.userGroupId) {
            if (this.grpLevel === 0) {
                this.workspaces = [{id: '1', name: 'My Workspace'}];
                this.workType = '1';
            } else if (this.grpLevel === 1) {
                this.workspaces = [{id: '1', name: 'My Workspace'}, {id: '2', name: 'Team Workspace'}];
                this.workType = '1';
            } else if (this.grpLevel === 2) {
                this.workspaces = [{id: '1', name: 'My Workspace'}];
                this.workType = '1';
            } else {
                this.workspaces = [{id: '2', name: 'My Team Workspace'}];
                this.workType = '2';
            }
            this.ticketSub = this._rest.getTicketTypeForTicketCreation_LNT(this.clientId, this.userGroupId).subscribe((res1) => {
                this.respObject = res1;
                this.ticketTypeLoaded = true;
                if (this.respObject.success) {
                    this.radioButton = this.respObject.details;
                    const storage = JSON.parse(sessionStorage.getItem('dd'));
                    if (storage === null) {
                        this.categorySelected = 0;
                        this.userSelected = 0;
                        this.ticketType = this.radioButton[0].id;
                        this.typeSeq = this.radioButton[0].seq;
                    } else {
                        const type = storage.type;
                        this.radioButton[0].checked = false;
                        for (let i = 0; i < this.radioButton.length; i++) {
                            // console.log(this.types[i].id, type);
                            if (this.radioButton[i].id === type) {
                                this.ticketType = this.radioButton[i].id;
                                this.radioButton[i].checked = true;
                                this.typeSeq = this.radioButton[i].seq;
                                break;
                            }
                        }
                        this.categorySelected = storage.cat;
                        this.userSelected = storage.user;
                    }
                    this.getTicketType = false;
                    if (this.grpLevel > 0) {
                        // this.checkFilterVal();
                        this._rest.getDashboardCategory(this.clientId, this.messageService.getUserId()).subscribe((res5) => {
                            this.respObject = res5;
                            if (this.respObject.success) {
                                // console.log(this.respObject.details.length)
                                if (this.respObject.details > 0) {
                                    this.getDynamicMenu_new();
                                } else {
                                    this.getCategory('load');
                                }
                            } else {
                                this.notifier.notify('error', this.respObject.errorMessage);
                            }
                        }, (err) => {

                        });
                    } else {
                        this.getDynamicMenu_new();
                    }
                    this._rest.checkIsLead(this.clientId, this.userGroupId, this.messageService.getUserId()).subscribe((res3) => {
                        this.respObject = res3;
                        if (this.respObject.success) {
                            this.islead = this.respObject.details[0].is_spoc;
                            // // console.log('this.islead:' + this.islead);

                            // ========================================================
                            if ((this.grpLevel === 1 && this.islead) || this.grpLevel >= 2) {
                                this._rest.getCategoryListSupportGroupWise(this.userGroupId, this.clientId,
                                    this.ticketType).subscribe((res4) => {
                                    this.respObject = res4;
                                    if (this.respObject.success) {
                                        this.respObject.details.unshift({id: 0, name: 'Select Category'});
                                        this.categories = this.respObject.details;
                                    } else {
                                        this.notifier.notify('error', this.respObject.errorMessage);
                                    }
                                }, (err) => {
                                    // this.isError = true;
                                    // this.errorMessage = this.messageService.SERVER_ERROR;
                                });
                            }
                            if (this.grpLevel === 1 && this.islead) {
                                this._rest.getAllLevelOneUser(this.clientId).subscribe((res5) => {
                                    this.respObject = res5;
                                    if (this.respObject.success) {
                                        this.isError = false;
                                        // // console.log(this.respObject);
                                        this.respObject.details.unshift({id: 0, name: 'Select Analyst'});
                                        this.users = this.respObject.details;
                                        // this.userSelected = 0;
                                    } else {
                                        this.notifier.notify('error', this.respObject.errorMessage);
                                    }
                                }, (err) => {
                                    // this.isError = true;
                                    // this.errorMessage = this.messageService.SERVER_ERROR;
                                });
                            }
                            // ==========================================================
                            // end user and l1 => dash bord detls
                            //   l1 lead => getDashBoardDtlsForTeamLead
                            //   l2 -l5 new api => getDashBoardDtlsForLeader

                        } else {

                        }
                    });

                } else {
                    this.isLoading = false;
                }
            });
        } else {
            this.ticketTypeLoaded = true;
            this.isLoading = false;
        }
        if (this.grpLevel === 0) {
            this.isLabel0 = true;
        } else if (this.grpLevel === 1) {
            this.isLabel1 = true;
        } else if (this.grpLevel >= 2) {
            this.isLabel2 = true;
        }
    }

    getCategory(type) {
        // this.baseCategories = [];
        // this.ticketTypes = [];
        // this.cat = [];
        this.seq = 1;
        if (type === 'btn') {
            this.isUpdate = true;
            // this.openCategory();
        } else {
            this.isUpdate = false;
            this.sevenLevelSelected = 0;
        }
        this.addedCat = [];
        this.openCategory();
        this.getFirstLevelCategory();
    }

    getDynamicMenu_new() {
        this.isLoading = true;
        const storage = this.messageService.getWorkspace();
        if (storage !== null) {
            this.workType = storage;
        }
        let specialFilterVal;
        if (this.grpLevel === 0) {
            specialFilterVal = '0';
        } else {
            specialFilterVal = '1';
        }
        this._rest.getDynamicMenuTicketTypeWise(this.clientId, this.ticketType,
            this.messageService.getUserId(), 1, this.userGroupId, this.workType).subscribe((res2) => {
            this.respObject = res2;
            // // console.log(JSON.stringify(this.respObject));
            if (this.respObject.success) {
                this.tilesData = [];
                this.selectedData = this.respObject.details;
                this.isLoading = false;
                this.tilesData = this.selectedData;
                for (let i = 0; i < this.selectedData.length; i++) {
                    this._rest.getDynamicTotCountMenuTicketDtls_new(this.clientId, this.userGroupId, this.ticketType, this.typeSeq,
                        this.selectedData[i].fid, this.categorySelected, this.userSelected, specialFilterVal).subscribe((res) => {
                        this.respObject = res;
                        // // console.log('data--Done=======', this.respObject);
                        if (this.respObject.success) {
                            document.getElementById('loader_' + this.respObject.details[0].id).hidden = true;
                            document.getElementById('count_' + this.respObject.details[0].id).innerText = this.respObject.details[0].value;
                        } else {
                            this.notifier.notify('error', this.respObject.errorMessage);
                        }
                    }, (err) => {
                    });
                }
                this._rest.checkOfflineDashNotification(this.clientId, this.userGroupId,
                    this.messageService.getUserId(), this.ticketType, 1).subscribe((res) => {
                    this.respObject = res;
                    if (this.respObject.success) {
                        const result = this.respObject.details;
                        // this.menus = this.respObject.details;
                        for (let i = 0; i < result.length; i++) {
                            const menuId = result[i].noti_type;
                            const displayelem = document.getElementById('display_' + menuId);
                            if (displayelem !== undefined && displayelem !== null) {
                                displayelem.classList.remove('none');
                            }

                        }
                    }
                });
                // // console.log('++++++++++++', JSON.stringify(this.tilesData));
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            // this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    createTicket() {
        sessionStorage.setItem('dd', JSON.stringify({
            type: this.ticketType,
            seq: this.typeSeq,
            user: this.userSelected,
            cat: this.categorySelected
        }));
        // this.route.navigate(['ticket/createTicketL&T']);
        if (this.messageService.createUrl !== undefined && this.messageService.createUrl !== null) {
            this.messageService.changeRouting(this.messageService.createUrl);
        }
    }

    onButtonChange(selectedButton) {
        // // console.log('+++++++++++++++++', selectedButton, selectedButton.value.id)
        this.ticketType = selectedButton.value.id;
        this.messageService.saveMenuData({
            type: this.ticketType,
            seq:this.typeSeq,
            user: this.userSelected,
            cat: this.categorySelected
        });
        this.getDynamicMenu_new();
    }

    goto(fid) {
        // // console.log('**********************', fid);

        sessionStorage.setItem('dd', JSON.stringify({
            id: fid,
            type: this.ticketType,
            seq:this.typeSeq,
            user: this.userSelected,
            cat: this.categorySelected
        }));
        if (this.messageService.viewUrl !== undefined && this.messageService.viewUrl !== null) {
            this.messageService.changeRouting(this.messageService.viewUrl);
        }
        // this.route.navigate(['ticket/viewTicketL&TSSC']);
    }

    onSelectGroup() {
        this.isLabel0 = false;
        this.isLabel1 = false;
        this.isLabel2 = false;
        this.islead = false;
        if (this.userGroupSelected !== 0) {
            this.userGroupId = this.userGroupSelected;
            for (let i = 0; i < this.userGroups.length; i++) {
                if (this.userGroups[i].groupId === this.userGroupId) {
                    this.groupName = this.userGroups[i].grpName;
                    this.grpLevel = this.userGroups[i].level;
                }
            }
            if (this.grpLevel === 0) {
                this.workType = '1';
                this.messageService.setWorkspace(this.workType);
                this.isLabel0 = true;
            } else if (this.grpLevel === 1) {
                this.isLabel1 = true;
            } else if (this.grpLevel >= 2) {
                this.isLabel2 = true;
                if (this.grpLevel > 2) {
                    this.workType = '2';
                } else {
                    this.workType = '1';
                }
                this.messageService.setWorkspace(this.workType);
            }
            this.messageService.saveSupportGroup({
                groupId: this.userGroupId,
                grpName: this.groupName,
                level: this.grpLevel
            });

            // console.log('-----group lavel -------' + this.grpLevel + '==============' + this.workType);
            this.onPageLoad();
        }
    }

    onSelectCategory() {
        this.userSelected = 0;
        this.getDynamicMenu_new();
    }

    onSelectUser() {
        this.categorySelected = 0;
        this.getDynamicMenu_new();
    }

    ngOnDestroy() {
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }

        if (this.ticketSub) {
            this.ticketSub.unsubscribe();
        }
        if (this.dashboardSubscribe) {
            this.dashboardSubscribe.unsubscribe();
        }
    }

    goTofaq() {
        // this.route.navigate(['ticket/faq']);
        if (this.messageService.faqUrl !== undefined && this.messageService.faqUrl !== null) {
            this.messageService.changeRouting(this.messageService.faqUrl);
        }
    }

    goToSearch() {
        sessionStorage.setItem('dd', JSON.stringify({
            type: this.ticketType,
            seq:this.typeSeq,
            user: this.userSelected,
            cat: this.categorySelected
        }));
        // this.route.navigate(['ticket/search']);
        if (this.messageService.searchUrl !== undefined && this.messageService.searchUrl !== null) {
            this.messageService.changeRouting(this.messageService.searchUrl);
        }
    }

    openCategory() {
        this.dataLoaded = true;
        this.commentDialogRef = this.dialog.open(this.addCategory, {
            disableClose: true
        });

    }

    submitCategory(type) {
        // console.log(JSON.stringify(this.selectedTitles));
        // console.log(JSON.stringify(this.secondLevelSelected))
        const cats = [];
        if (this.selectedTitles.length > 0) {
            if (this.seq === 1) {
                for (let i = 0; i < this.selectedTitles.length; i++) {
                    let matched = false;
                    for (let j = 0; j < this.firstLevelSelected.length; j++) {
                        if (this.selectedTitles[i] === this.firstLevelSelected[j]) {
                            matched = true;
                            break;
                        }
                    }
                    if (!matched) {
                        cats.push(this.selectedTitles[i]);
                    }
                }
            } else {
                for (let i = 0; i < this.selectedTitles.length; i++) {
                    let matched = false;
                    for (let j = 0; j < this.secondLevelSelected.length; j++) {
                        if (this.selectedTitles[i] === this.secondLevelSelected[j]) {
                            matched = true;
                            break;
                        }
                    }
                    if (!matched) {
                        cats.push(this.selectedTitles[i]);
                    }
                }
            }
            // console.log(JSON.stringify(cats));
            if (cats.length > 0) {
                this.dataLoaded = false;
                const data = {
                    clientId: this.clientId,
                    user_id: this.messageService.getUserId(),
                    catList: cats,
                    seq: this.seq
                };
                this._rest.insertDashboard(data).subscribe((res) => {
                    this.respObject = res;
                    this.dataLoaded = true;
                    if (this.respObject.success) {
                        // console.log(this.seq);
                        for (let k = 0; k < cats.length; k++) {
                            this.secondLevelSelected.push(cats[k]);
                        }
                        if (this.seq === 9) {
                            this.isUpdate = true;
                        } else {
                            this.isUpdate = false;
                        }
                        this.notifier.notify('success', this.respObject.details);
                    } else {
                        this.notifier.notify('error', this.respObject.errorMessage);
                        // alert(this.respObject.errorMessage);
                    }
                }, (err) => {
                });
            } else {
                this.notifier.notify('error', 'No New category Selected');
            }
        } else {
            this.dataLoaded = false;
            const data = {
                clientId: this.clientId,
                user_id: this.messageService.getUserId(),
                catList: this.secondLevelSelected,
                seq: this.seq
            };
            this._rest.deleteAllDashboardCat(data).subscribe((res: any) => {
                // this.respObject = res;
                this.dataLoaded = true;
                if (res.success) {
                    this.secondLevelSelected = [];
                    if (res.details.value) {
                        this.isUpdate = true;
                    } else {
                        this.isUpdate = false;
                    }
                    this.notifier.notify('success', res.details.message);
                } else {
                    this.notifier.notify('error', res.errorMessage);
                }
            }, (err) => {
            });
        }
    }

    close() {
        this.commentDialogRef.close();
        this.getDynamicMenu_new();
    }

    onWorkTypeChange() {
        // this.wor
        this.messageService.setWorkspace(this.workType);
        this.getDynamicMenu_new();
    }


    getCategoryParentWise(type) {
        if (type === 2) {
            this.seq++;
        } else {
            this.seq--;
        }
        if (this.seq < 10) {
            this.prevDisplayCount = this.displayCount;
            this.prevTotalCount = this.totalCat;
            this.displayCount = 0;
            this.totalCat = 0;
            this.addedCat = [];
            // console.log('seq:' + this.seq);
            this.page = 1;
            if (this.seq === 1) {
                this.getFirstLevelCategory();
            } else {
                this.getCategoriesParentWise(0, 'n');
            }
        }
    }

    getFirstLevelCategory() {
        this.dataLoaded = false;
        this._rest.getCategoryByGroupForLnTCHR(this.clientId, this.ticketType, this.userGroupId).subscribe((res) => {
            this.respObject = res;
            this.dataLoaded = true;
            // let indexArray = [];
            if (this.respObject.success) {
                //
                this.dataset = this.respObject.details.cat;
                // this.gridOptions.preselectedRows = [0];
                this.firstLevelSelected = this.respObject.details.selected;
                this.rowSelected = this.getArrayIndex(this.dataset, this.firstLevelSelected);
                setTimeout(() => {
                    this.gridObj.setSelectedRows(this.rowSelected);
                }, 100);
                // console.log(JSON.stringify(this.rowSelected));
                this.lastId = this.respObject.details.cat[0].id;
                this.totalCat = this.respObject.details.cat.length;
                this.displayCount = this.totalCat;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    getCategoriesParentWise(lastId, type) {
        this.dataLoaded = false;
        this.rowSelected = [];
        this._rest.getMultipleAttributesParentWise(this.clientId, this.seq, lastId, this.limit, type).subscribe((res) => {
            this.respObject = res;
            this.dataLoaded = true;
            // let indexArray = [];
            // this.dataset = [];
            if (this.respObject.success) {
                if (this.respObject.details.cat.length > 0) {
                    // this.displayCount = 0;
                    this.dataset = this.respObject.details.cat;
                    this.gridObj.getSelectionModel().setSelectedRanges([]);
                    this.secondLevelSelected = this.respObject.details.selected;
                    this.rowSelected = this.getArrayIndex(this.dataset, this.secondLevelSelected);
                    setTimeout(() => {
                        this.gridObj.setSelectedRows(this.rowSelected);
                    }, 100);
                    this.lastId = this.respObject.details.lastId;
                    this.firstId = this.respObject.details.firstId;
                    if (lastId === 0) {
                        this.totalCat = this.respObject.details.total;
                    }
                    if (type === 'n') {
                        this.displayCount = this.displayCount + this.respObject.details.cat.length;
                    } else {
                        const rem = this.displayCount % this.limit;
                        // console.log(rem, typeof rem);
                        if (rem === 0) {
                            this.displayCount = this.displayCount - this.respObject.details.cat.length;
                        } else {
                            this.displayCount = this.displayCount - rem;
                        }
                    }
                } else {
                    this.seq--;
                    this.notifier.notify('error', 'No Category Selected.Please Submit atleast One category to proceed');
                }
            } else {
                this.seq--;
                this.totalCat = this.prevTotalCount;
                this.displayCount = this.prevDisplayCount;
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
        });
    }

    onLimitChange(selectedIndex: any) {
        this.displayCount = 0;
        this.totalCat = 0;
        this.addedCat = [];
        this.page = 1;
        this.getCategoriesParentWise(0, 'n');
    }

    getLimitedCategory(type) {
        if (type === 'n') {
            this.page++;
            // console.log('inside :' + this.page);
            this.getCategoriesParentWise(this.lastId, type);
        } else {
            this.page--;
            // console.log('inside :' + this.page);
            this.getCategoriesParentWise(this.firstId, type);
        }
    }

    onCellClicked(e: any, args: any) {
        // console.log('------->' + JSON.stringify(args));
        const selectedId = this.gridObj.getDataItem(args.row);
        // console.log('------->' + JSON.stringify(selectedId));
        // console.log('before:' + JSON.stringify(this.secondLevelSelected));
        let IdPos;
        if (this.seq === 1) {
            IdPos = this.firstLevelSelected.indexOf(selectedId.id);
        } else {
            IdPos = this.secondLevelSelected.indexOf(selectedId.id);
        }
        if (IdPos > -1) {
            const data = {
                parentPath: selectedId.parentPath,
                id: selectedId.id,
                clientId: this.clientId,
                seq: this.seq
            };
            this._rest.deleteDashboardCat(data).subscribe((res: any) => {
                if (res.success) {
                    if (this.seq === 1) {
                        this.firstLevelSelected.splice(IdPos, 1);
                    } else {
                        if (res.details.value) {
                            this.isUpdate = true;
                        } else {
                            this.isUpdate = false;
                        }
                        this.secondLevelSelected.splice(IdPos, 1);
                    }
                    this.notifier.notify('success', res.details.message);
                } else {
                    this.notifier.notify('error', res.errorMessage);
                }
            }, (err) => {

            });
        } else {
            const data = {
                seq: this.seq,
                categoryId: selectedId.id,
                clientId: this.clientId
            };
            this._rest.insertDashboardCat(data).subscribe((res: any) => {
                if (res.success) {
                    if (this.seq === 1) {
                        this.firstLevelSelected.push(selectedId.id);
                    } else {
                        if (this.seq === 9) {
                            this.isUpdate = true;
                        } else {
                            this.isUpdate = false;
                        }
                        this.secondLevelSelected.push(selectedId.id);
                    }
                    this.notifier.notify('success', 'Category added to dashboard');
                } else {
                    this.notifier.notify('error', res.errorMessage);
                }
            }, (err) => {

            });
        }

        if (args.cell !== 0) {
            this.gridObj.setSelectedRows(this.rowSelected);
        }
    }

    goToGroupMap() {
        sessionStorage.setItem('dd', JSON.stringify({
            type: this.ticketType,
            user: this.userSelected,
            cat: this.categorySelected
        }));
        // this.route.navigate(['ticket/search']);
        if (this.messageService.groupMapUrl !== undefined && this.messageService.groupMapUrl !== null) {
            this.messageService.changeRouting(this.messageService.groupMapUrl);
        }
    }

    getArrayIndex(mainArr, indexArr) {
        const selectSeq = [];
        for (let i = 0; i <= indexArr.length - 1; i++) {
            for (let k = 0; k <= mainArr.length - 1; k++) {
                if (indexArr[i] === mainArr[k].id) {
                    selectSeq.push(k);
                    break;
                }
            }
        }
        return selectSeq;
    }
}
